import { Button, ButtonDesign, MessageBoxTypes } from '@ui5/webcomponents-react';
import { useTranslation } from 'react-i18next';
import { useStyles } from './EditQuery.jss';
import '@ui5/webcomponents-icons/dist/edit';
import { useState } from 'react';
import { ConfirmationDialog } from 'components/shared/ConfirmationDialog';

type EditQueryProps = {
  toggleEditMode: () => void;
  allowEditModeWithoutConfirmation: boolean;
  setAllowEditModeWithoutConfirmation: (value: boolean) => void;
};

export const EditQuery: React.FC<EditQueryProps> = (props) => {
  const { toggleEditMode, allowEditModeWithoutConfirmation, setAllowEditModeWithoutConfirmation } =
    props;
  const { t } = useTranslation();
  const classes = useStyles();
  const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false);

  const tryChangeToEditState = () => {
    allowEditModeWithoutConfirmation ? toggleEditMode() : setIsConfirmationDialogOpen(true);
  };

  const onConfirmEditMode = () => {
    setAllowEditModeWithoutConfirmation(true);
    toggleEditMode();
  };

  return (
    <>
      <Button
        className={classes.actionGroupItem}
        data-testid="edit-query-item"
        data-help-id="edit-query-item"
        id="edit-query-button"
        onClick={tryChangeToEditState}
        design={ButtonDesign.Default}
      >
        {t('display-query-edit-query-item')}
      </Button>
      <ConfirmationDialog
        open={isConfirmationDialogOpen}
        data-testid="confirmation-dialog-edit-query"
        type={MessageBoxTypes.Confirm}
        onClose={() => setIsConfirmationDialogOpen(false)}
        onConfirm={onConfirmEditMode}
      >
        {t('confirm-edit-mode-message')}
      </ConfirmationDialog>
    </>
  );
};
